import { render } from "./IconToggle.vue?vue&type=template&id=84813c7a&ts=true"
import script from "./IconToggle.vue?vue&type=script&lang=ts"
export * from "./IconToggle.vue?vue&type=script&lang=ts"

import "./IconToggle.vue?vue&type=style&index=0&id=84813c7a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__